var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5333 30.1057C14.6593 28.1025 15.139 26.1953 15.9107 24.446C13.3522 24.2087 11.0312 23.1445 9.22198 21.5252L11.445 19.0413C12.9204 20.362 14.8648 21.163 17.0002 21.163C17.294 21.163 17.5837 21.1478 17.8687 21.1183C20.7118 17.3615 25.1103 14.8472 30.1058 14.5332C28.9488 8.34795 23.5212 3.66667 17.0002 3.66667C9.63636 3.66667 3.66683 9.6362 3.66683 17C3.66683 23.521 8.34811 28.9487 14.5333 30.1057ZM28.7057 18.06C23.3153 19.066 19.0662 23.3152 18.0602 28.7055L28.7057 18.06ZM33.6668 17C33.6668 17.2795 33.66 17.5573 33.6463 17.8333L17.8335 33.6462C17.5575 33.6598 17.2797 33.6667 17.0002 33.6667C7.79541 33.6667 0.333496 26.2047 0.333496 17C0.333496 7.79525 7.79541 0.333334 17.0002 0.333334C26.2048 0.333334 33.6668 7.79525 33.6668 17ZM13.6668 13.6667C13.6668 15.0473 12.5475 16.1667 11.1668 16.1667C9.78611 16.1667 8.66683 15.0473 8.66683 13.6667C8.66683 12.286 9.78611 11.1667 11.1668 11.1667C12.5475 11.1667 13.6668 12.286 13.6668 13.6667ZM25.3335 13.6667C25.3335 15.0473 24.2142 16.1667 22.8335 16.1667C21.4528 16.1667 20.3335 15.0473 20.3335 13.6667C20.3335 12.286 21.4528 11.1667 22.8335 11.1667C24.2142 11.1667 25.3335 12.286 25.3335 13.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreetIcon);
export default __webpack_public_path__ + "static/media/greetIcon.3a13a5cc89ab0d6f26ea96e75b64e6ec.svg";
export { ForwardRef as ReactComponent };